import { IKindCompilationProps } from '../KindCompilation/KindCompilation.types';
import type * as T from './KindCompilationSlider.types';
export const getAdaptedItems = (items: T.IKindCompilationSliderProps['items']): IKindCompilationProps[] => {
    return items.map(({ title, url, kinds, kinds_count }) => {
        const imageList = kinds
            ?.map((item) => ({ src: item.main_image }))
            .slice(0, 5);
        return {
            title,
            url,
            imageList,
            kinds_count,
        };
    });
};
